import React, { useState } from "react";
import { Modal, Form, Select, Space, Button, message } from "antd";
import { BookyInput } from '../../Components/Forms/BookyInput';
import { BookyCheckbox } from '../../Components/Forms/BookyCheckbox';
import { MemberFieldTypes } from '../../Types/MemberFieldTypes';
import { UI_CONTROLS } from '../../Types/FieldTypes';
import { CustomField } from '../../Types/CustomField';
import { MemberFieldService } from '../../Services/MemberFieldService';

interface AddCustomFieldModalProps {
    open: boolean;
    onCancel: () => void;
    onFieldAdded: () => Promise<void>;
    allCustomLists: any[];
    GetText: (key: string) => string;
}

const AddCustomFieldModal: React.FC<AddCustomFieldModalProps> = ({ open, onCancel, onFieldAdded, allCustomLists, GetText }) => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);

    const handleAddField = async (values: any) => {
        setLoading(true);
        try {
            await MemberFieldService.AddNewField({
                columnType: MemberFieldTypes.Custom,
                nameAdmin: values.name,
                namePublic: values.name,
                visibleInAdmin: values.visibleAdmin,
                visiblePublic: values.visiblePublic,
                mandatoryAdmin: values.requiredAdmin,
                mandatoryPublic: values.requiredPublic,
                helpTextPublic: values.placeholder,
                uiControl: values.control,
                alternatives: values.alternatives,
                customListId: values.lookupListId || null
            });

            message.success(GetText('Common_Saved'));
            await onFieldAdded();
            form.resetFields();
        } catch (error) {
            console.error('Failed to add custom field:', error);
            // You might want to show an error message here
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal
            title={GetText("MemberFieldSettings_AddField")}
            open={open}
            onCancel={onCancel}
            footer={null}
            destroyOnClose
        >
            <Form layout="vertical" form={form} onFinish={handleAddField}>
                <BookyInput label={GetText("MemberFields_FieldName")} name="name" req />
                <BookyCheckbox label="Synlig admin" name="visibleAdmin" />
                <BookyCheckbox label="Synlig medlem" name="visiblePublic" />
                <BookyCheckbox label="Obligatorisk admin" name="requiredAdmin" />
                <BookyCheckbox label="Obligatorisk medlem" name="requiredPublic" />
                <Form.Item label="UI-kontroll" name="control" rules={[{ required: true }]}>
                    <Select
                        onChange={() => {
                            form.validateFields(["control"]);
                        }}
                    >
                        {UI_CONTROLS.map(t => (
                            <Select.Option key={t.value} value={t.value}>{t.label}</Select.Option>
                        ))}
                    </Select>
                </Form.Item>
                <Form.Item
                    noStyle
                    shouldUpdate={(prev, curr) => prev.control !== curr.control}
                >
                    {({ getFieldValue }) =>
                        getFieldValue("control") === "lookup" ? (
                            <Form.Item
                                label="Uppslag CustomList"
                                name="lookupListId"
                                rules={[{ required: true, message: "Välj en lista för uppslag" }]}
                            >
                                <Select placeholder="Välj lista">
                                    {allCustomLists.map(list => (
                                        <Select.Option key={list.id} value={list.id}>{list.name}</Select.Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        ) : null
                    }
                </Form.Item>
                <BookyInput label="Hjälptext" name="placeholder" />
                <BookyInput label="Alternativ (semikolonseparerade)" name="alternatives" />
                <Form.Item>
                    <Space>
                        <Button htmlType="submit" type="primary" loading={loading}> Lägg till </Button>
                        <Button onClick={onCancel} disabled={loading}> Avbryt </Button>
                    </Space>
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default AddCustomFieldModal;
